export class Mark {
  id: number;
  name: string;
  icon: string;
  mark_id?: number;
  checked?: boolean;
}
